import { defineComponent as _defineComponent } from 'vue'
import { fetchAllMatCode } from '@/apis/common/materialMatCode'
import store from '@/store'
import { onMounted, ref, watch } from 'vue'

interface PropsType {
  desMaterialList?: string[]
  desMaterialSwitch?: boolean
  isPrePaiban?: boolean
  longPlankCuttingEnable?: boolean
  hideHeader?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'm-accord-texture-cut',
  props: {
    desMaterialList: { default: () => [] },
    desMaterialSwitch: { type: Boolean, default: false },
    isPrePaiban: { type: Boolean },
    longPlankCuttingEnable: { type: Boolean },
    hideHeader: { type: Boolean, default: false }
  },
  emits: ['changeAccordMSw'],
  setup(__props: any, { expose, emit }) {

const props = __props as { desMaterialList: string[], desMaterialSwitch: boolean, isPrePaiban?: boolean, longPlankCuttingEnable?: boolean, hideHeader: boolean }


const { desMaterialList, desMaterialSwitch, isPrePaiban = false } = props

// 功能开关
const funSwitch = ref(desMaterialSwitch)
// 对话框显示
const modalVisable = ref(false)
// 输入框材质
const material = ref('')
// 当前指定材质列表
const inputList = ref<string[]>(desMaterialList)
// 所有材质列表
const allMaterialList = ref<string[]>()
// 下拉框展示的材质列表
let allMaterialListShow = ref<string[]>()

onMounted(async () => {
  try {
    const resList = await fetchAllMatCode(store.state.userInfo.id)
    allMaterialList.value = resList.data
    // 默认展示5个
    allMaterialListShow.value = allMaterialList.value
  } catch (error) {
    console.log(error)
  }
})
// 监听复原功能 为啥要写两个watch！！！为了避免副作用
watch(
  () => props.desMaterialSwitch,
  (val) => {
    funSwitch.value = val
  },
  {
    deep: true,
  }
)
watch(
  () => props.desMaterialList,
  (val) => {
    inputList.value = val
  },
  {
    deep: true,
  }
)
/**
 * @desc 添加知道材质
 * @param material 输入的材质
 */
const addInput = (material: string) => {
  material.trim() && inputList.value.push(material)
}
/**
 * @desc 删除指定材质
 * @param idx 指定索引
 */
const handlerDeleteSearch = (idx: number) => {
  inputList.value.splice(idx, 1)
}
/**
 * @desc 输入字符下拉框匹配对应数据
 * @param e
 */
const handlerInpMaterial = (e: Event) => {
  if (e.target) {
    const inpVal = e.target?.value
    // if (!inpVal.trim()) {
    //   allMaterialListShow.value = []
    //   return
    // }

    const reg = new RegExp(`${inpVal}.*`)
    // 模糊匹配
    allMaterialListShow.value = allMaterialList.value?.filter((it) =>
      reg.test(it)
    )
  }
}
/**
 * @desc 选择下拉框材质
 * @param materiaInp
 */
const handlerSelectMaterial = (materiaInp: string) => {
  material.value = materiaInp
}
const handleOk = () => {
  // 避免重复
  !inputList.value.includes(material.value) && addInput(material.value)
  modalVisable.value = false
}
/**
 * @desc 保存指定材质 将此组件指定的数据赋值到formData中
 * @param source
 */
const saveAccordmCut = (source: any) => {
  const curObj = {
    desMaterialList: inputList.value,
    desMaterialSwitch: funSwitch.value,
  }
  Object.assign(source, curObj)
}
const handlerSwitch = (data: boolean) => {
  emit('changeAccordMSw', data)
}

expose({
  saveAccordmCut,
})

return { __sfc: true,props, desMaterialList, desMaterialSwitch, isPrePaiban, emit, funSwitch, modalVisable, material, inputList, allMaterialList, allMaterialListShow, addInput, handlerDeleteSearch, handlerInpMaterial, handlerSelectMaterial, handleOk, saveAccordmCut, handlerSwitch }
}

})